export enum EStatus {
  ACTIVE = 1,
  INACTIVE = 2
}

export enum EStatusLabel {
  ACTIVE = 'Active',
  INACTIVE = 'Inactive'
}

export enum ReviewOption {
  SUPERVISOR_SIGNOFF = 1,
  ACKNOWLEDGEMENT = 2,
}

export const REVIEW_OPTION_LABELS = {
  [ReviewOption.SUPERVISOR_SIGNOFF]: 'Require supervisor signoff',
  [ReviewOption.ACKNOWLEDGEMENT]: 'Require acknowledgement',
} as const